module.exports = __webpack_public_path__ + "img/ads-image.2bdb7364.png";